import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'

export const SectionTitle = styled.div<{
  $mt?: number
  $mb?: number
  $ml?: number
  $mr?: number
}>`
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: ${palette.blue[700]};

  ${({ $mt }) => $mt && `margin-top: ${$mt}px`};
  ${({ $mb }) => $mb && `margin-bottom: ${$mb}px`};
  ${({ $ml }) => $ml && `margin-left: ${$ml}px`};
  ${({ $mr }) => $mr && `margin-right: ${$mr}px`};
`
